import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import WorldView from "../pages/worldview/page";
import Characters from "../pages/characters/page";
import Settings from "../pages/settings/page";
import Faq from "../pages/faq/page";
import About from "../pages/about/page";
import Contact from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/worldview",
    element: <WorldView />,
  },
  {
    path: "/characters",
    element: <Characters />,
  },
  {
    path: "/settings",
    element: <Settings />,
  },
  {
    path: "/faq",
    element: <Faq />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;